//imports
import { Component, OnInit, Input } from '@angular/core';
import {allPages, scientistMenu, patientMenu, employeeMenu} from 'src/app/interfaces/menus';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-profile-modal',
  templateUrl: './profile-modal.page.html',
  styleUrls: ['./profile-modal.page.scss'],
})
export class ProfileModalPage implements OnInit {
  //declared variables
  @Input() profile: number;
  @Input() showBack: boolean;
  allItems = [];
  selectedItems = [];
  lastTimestamp;

  //constructor
  constructor(private modalController: ModalController) { }

  // happens when page is initialize
  ngOnInit() {
    if (this.profile == 1) {
      Object.assign(this.selectedItems, scientistMenu);
    } else if (this.profile == 2) {
      Object.assign(this.selectedItems, patientMenu);
    } else if (this.profile == 3) {
      Object.assign(this.selectedItems, employeeMenu);
    } else if (typeof localStorage.getItem('appMenu') != 'undefined' && localStorage.getItem('appMenu') != null) {
      try {
        this.selectedItems = JSON.parse(localStorage.getItem('appMenu'));
      } catch { }
    }
    this.allItems = allPages.filter(page => this.selectedItems.filter(selected => selected.url == page.url).length <= 0);
  }

  // reorders the pages
  public reorderItems(ev, list) {
    if (ev.timeStamp != this.lastTimestamp) {
      this.lastTimestamp = ev.timeStamp;
      const itemMove = list.splice(ev.detail.from, 1)[0];
      list.splice(ev.detail.to, 0, itemMove);
      ev.detail.complete();
    }
  }

  // adds page to selectedpages
  public addItem(item) {
    this.allItems.splice(this.allItems.indexOf(item), 1);
    this.selectedItems.push(item);
  }

  // removes page from selectedpages
  public removeItem(item) {
    this.selectedItems.splice(this.selectedItems.indexOf(item), 1);
    this.allItems.push(item);
  }

  // applies settings
  public apply() {
    this.modalController.dismiss({ change: true, menu: this.selectedItems });
  }

  // goes back from settings
  public back() {
    this.modalController.dismiss({ change: true, menu: null });
  }

  // cancels the settings modal
  public cancel() {
    this.modalController.dismiss({ change: false });
  }
}
